/* src/app/components/admin/cases/reshard-case-index-dialog/reshard-case-index-dialog.component.scss */
.mat-mdc-dialog-content {
  padding: 12px 24px 12px 24px;
  min-width: 200px;
  min-height: 50px;
  display: flex;
  flex-direction: column;
}
.mat-mdc-dialog-title {
  padding: 24px 24px 24px 20px;
  margin: -24px -24px 10px -24px;
  background-color: rgb(48, 63, 159);
  color: white;
}
.title {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
}
.larger-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
:host-context(.dark-theme) .title {
  color: rgba(255, 255, 255, 0.6);
}
/*# sourceMappingURL=reshard-case-index-dialog.component.css.map */
